/**
 * WaitAction - behavior tree action for waiting/delaying.
 */

import { EngineClass } from '../../../../../systems/ClassRegistry.js';
import { BehaviorStatus } from '../../../BehaviorNode.js';
import { BehaviorAction, type BehaviorActionOptions } from '../../BehaviorAction.js';

import type { Blackboard } from '../../../blackboard/Blackboard.js';

export interface WaitActionOptions extends BehaviorActionOptions {
  duration?: number;
  randomDuration?: boolean;
}

@EngineClass('WaitAction')
export class WaitAction extends BehaviorAction {
  private duration: number;
  private randomDuration: boolean;
  private startTime: number = 0;
  private waitDuration: number = 0;

  constructor(options: WaitActionOptions = {}) {
    super({
      name: 'Wait',
      ...options
    });

    this.duration = options.duration ?? 1.0;
    this.randomDuration = options.randomDuration ?? false;
  }

  protected override onInitialize(blackboard: Blackboard): void {}

  protected override onEnter(blackboard: Blackboard): void {
    const targetDuration = this.duration;

    // Apply randomization if enabled
    if (this.randomDuration) {
      this.waitDuration = Math.random() * targetDuration;
    } else {
      this.waitDuration = targetDuration;
    }

    this.startTime = Date.now() / 1000;
  }

  protected override async onUpdate(blackboard: Blackboard, deltaTime: number): Promise<BehaviorStatus> {
    const currentTime = Date.now() / 1000;
    const elapsedTime = currentTime - this.startTime;

    if (elapsedTime >= this.waitDuration) {
      return BehaviorStatus.Success;
    }

    return BehaviorStatus.Running;
  }

  protected override onExit(blackboard: Blackboard, status: BehaviorStatus): void {}
}
